import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ModuleService } from './module.service';
import { Module as ModuleInterface } from '../../modules/module.interface';

const service = new ModuleService();

export interface ModuleState {}

const ModuleStore: Module<ModuleState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getModules(context, tenantId: number) {
         return await service.getModules(tenantId);
      },
      async addModules(context, payload: { tenantId: number; modules: Array<ModuleInterface> }) {
         return await service.postModulesBatch(payload.tenantId, payload.modules).then((modules) => {
            modules.forEach((module) => {
               context.commit('tenant/ADD_TENANT_MODULE', module, { root: true });
            });
         });
      },
      async deleteModules(context, payload: { tenantId: number; modules: Array<ModuleInterface> }) {
         return await service.deleteModulesBatch(payload.tenantId, payload.modules).then((modules) => {
            modules.forEach((module) => {
               context.commit('tenant/REMOVE_TENANT_MODULE', module.id, { root: true });
            });
         });
      },
   },
};

export default ModuleStore;
